module.exports = __webpack_public_path__ + "static/media/w_king.529ef086.png";